"use client";

import { cn, Icon, Tooltip } from "@kyan/ui";

import { useTheme } from "#/hooks/useTheme";
import { useEoa } from "#/store/wallet/eoa/eoa";

export const ThemeSwitcher: React.FC = () => {
  const { isEoaConnected } = useEoa();
  const { icon, label, handleToggleTheme } = useTheme();

  return (
    <div
      className={cn(
        "border-divider hidden h-full items-center justify-center lg:flex lg:w-16",
        { "border-l": isEoaConnected },
      )}
    >
      <Tooltip side="bottom" content={label}>
        <Icon
          size="xl"
          name={icon}
          hoverEffect="circle"
          className="flex size-10 items-center justify-center"
          onClick={handleToggleTheme}
        />
      </Tooltip>
    </div>
  );
};
